import { useEffect, useState } from "react";

// Input data in formato italiano gg/mm/aaaa. Espone/riceve il valore in ISO (yyyy-mm-dd),
// così è un drop-in di <input type="date">: value=ISO, onChange=(iso)=>...
function isoToIt(iso) {
  if (!iso) return "";
  const m = String(iso).slice(0, 10).split("-");
  return m.length === 3 ? `${m[2]}/${m[1]}/${m[0]}` : "";
}
function itToIso(it) {
  const m = (it || "").match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return null;
  const [, d, mo, y] = m;
  const dt = new Date(`${y}-${mo}-${d}T00:00:00`);
  if (isNaN(dt) || dt.getDate() !== Number(d) || dt.getMonth() + 1 !== Number(mo)) return null;
  return `${y}-${mo}-${d}`;
}

export default function DateIT({ value, onChange, disabled, style, ...rest }) {
  const [text, setText] = useState(isoToIt(value));
  useEffect(() => { setText(isoToIt(value)); }, [value]);

  const handle = (e) => {
    let v = e.target.value.replace(/[^\d/]/g, "");
    // auto-inserimento slash
    const digits = v.replace(/\//g, "").slice(0, 8);
    let out = digits;
    if (digits.length > 4) out = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
    else if (digits.length > 2) out = `${digits.slice(0, 2)}/${digits.slice(2)}`;
    setText(out);
    if (out === "") { onChange(""); return; }
    const iso = itToIso(out);
    if (iso) onChange(iso);
  };

  return (
    <input type="text" inputMode="numeric" placeholder="gg/mm/aaaa" maxLength={10}
      value={text} onChange={handle} disabled={disabled} style={style} {...rest} />
  );
}
